import { FC } from "react";
import { Screen } from "../screen/Screen";

export const Stats: FC = () => {
    return <Screen title="Stats" />;
};
